import React from 'react'
import MiscRecordDetailCard from './MiscRecordDetailCard'
import { DATA_TYPE_EXAMPLES } from './MiscRecordDetailUtils'

const MiscRecordDetailGeneralTab = ({
  cards,
  unusedFields,
  selectedCardId,
  selectedFieldId,
  onCardClick,
  onFieldClick,
  onAddCard,
  onMoveFieldUp,
  onMoveFieldDown,
  onMoveCardLeft,
  onMoveCardRight,
}) => {
  const sortedCards = [...cards].sort((a, b) => a.SortOrder - b.SortOrder)

  return (
    <div className="misc-record-detail-general-tab">
      <div className="cards-row">
        {sortedCards.map((card, i) => (
          <MiscRecordDetailCard
            key={card.CardId}
            card={card}
            isSelected={card.CardId === selectedCardId}
            selectedFieldId={selectedFieldId}
            onCardClick={onCardClick}
            onFieldClick={onFieldClick}
            onMoveFieldUp={(index) => onMoveFieldUp(card.CardId, index)}
            onMoveFieldDown={(index) => onMoveFieldDown(card.CardId, index)}
            onMoveCardLeft={() => onMoveCardLeft(i)}
            onMoveCardRight={() => onMoveCardRight(i)}
            isFirstCard={i === 0}
            isLastCard={i === sortedCards.length - 1}
          />
        ))}
      </div>
      <button className="add-card-btn" onClick={onAddCard}>+ Add Card</button>
      <div className="unused-fields-card">
        <div className="unused-card-header">Unused Fields</div>
        <div className="unused-card-fields">
          {unusedFields.map((field) => (
            <div
              key={`field-${field.MiscellaneousFieldId}`}
              className="unused-field-row"
              role="button"
              tabIndex={0}
              onClick={() => onFieldClick(field, null)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onFieldClick(field, null) } }}
            >
              <span className="field-label">{field.Label || field.DbFieldName}</span>
              <span className="field-colon">{DATA_TYPE_EXAMPLES[field.DataType] != null ? ':' : ''}</span>
              <span className="field-example">{DATA_TYPE_EXAMPLES[field.DataType] ?? ''}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MiscRecordDetailGeneralTab
